import { render } from "./DeleteUserAccount.vue?vue&type=template&id=17f01ddc&scoped=true"
import script from "./DeleteUserAccount.vue?vue&type=script&lang=js"
export * from "./DeleteUserAccount.vue?vue&type=script&lang=js"

import "./DeleteUserAccount.vue?vue&type=style&index=0&id=17f01ddc&scoped=true&lang=css"

import exportComponent from "/home/gp/git/git.glitchedpolygons.ch/locales.glitchedpolygons.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f01ddc"]])

export default __exports__